import { API_REQUEST, GET_CURRENT_PROPERTY_DETAILS } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";

// Get current property details action
export const getCurrentPropertyDetails = (roll: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/get_property/${roll}`,
        next: GET_CURRENT_PROPERTY_DETAILS,
        method: 'GET',
        authorization: true
    }
});